import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';
import { Logger } from '@/lib/Logging';

const logger = new Logger('formatDate.ts');

export function formatDate(date: Date, locale?: string): string {
  const localLocale = locale ?? currentLocaleConfig().dateFormatLocale;

  try {
    const month = date.toLocaleDateString(localLocale, { month: 'short' });
    const day = date.toLocaleDateString(localLocale, { day: '2-digit' });
    const year = date.toLocaleDateString(localLocale, { year: 'numeric' });

    return `${month} ${day}, ${year}`;
  } catch (error) {
    logger.error({
      message: `Error formatting date with locale ${localLocale}`,
      context: error,
    });

    return formatDate(date, 'en-US');
  }
}
